import { RefObject, useEffect, useState } from 'react';

import type { VimeoVideoElement } from '@/lib/player/types';

async function getCastAvailable(
  videoRef: RefObject<VimeoVideoElement | null>,
): Promise<boolean> {
  if (!videoRef.current?.api?.getRemotePlaybackAvailability) {
    return false;
  }

  return await videoRef.current.api
    .getRemotePlaybackAvailability()
    .catch(() => false);
}

export function useVimeoCastAvailability(
  videoRef: RefObject<VimeoVideoElement | null>,
) {
  const [isCastAvailable, setIsCastAvailable] = useState(false);

  useEffect(() => {
    void getCastAvailable(videoRef)
      .then(isAvailable => {
        setIsCastAvailable(isAvailable);
      })
      .catch(() => {
        setIsCastAvailable(false);
      });
  }, [videoRef]);

  return isCastAvailable;
}
